module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "Breadcrumbs",
    class: {
      'Breadcrumbs--large': _vm.large
    }
  }, [(_vm.showLock) ? _c('icon', {
    staticClass: "Breadcrumbs-lockIcon",
    attrs: {
      "name": "lock",
      "width": "11px",
      "height": "11px"
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.items), function(item, index) {
    return [(_vm.leadingCaret) ? _c('span', {
      staticClass: "Breadcrumbs-divider Breadcrumbs-leadingCaret t-caps-md"
    }, [_vm._v("›")]) : _vm._e(), _vm._v(" "), _c(item.route ? 'router-link' : 'span', {
      tag: "component",
      staticClass: "Breadcrumbs-item",
      class: {
        't-caps-md': !item.large,
        't-heading-caps': item.large,
        'Breadcrumbs-item--isLarge': item.large
      },
      attrs: {
        "to": item.route
      }
    }, [_vm._v("\n      " + _vm._s(item.title) + "\n    ")]), _vm._v(" "), (index < _vm.items.length - 1 || _vm.trailingCaret) ? _c('span', {
      staticClass: "Breadcrumbs-divider t-caps-md"
    }, [_vm._v("›")]) : _vm._e()]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4c5da7e1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Breadcrumbs.vue
// module id = 766
// module chunks = 1474